var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"confirm-icon"},[_c('div',{staticClass:"confirm-icon__wrapper",class:{ 'confirm-icon__wrapper--checked': _vm.checked }},[_c('icon',{staticClass:"confirm-icon__icon",attrs:{"name":"check-circle","inline":false}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }